import React from 'react';
import {formatManagementGeneratedOn} from '../utils/managementOverviewFormatters';

interface ReportFooterProps {
    customerName: string;
    generatedOn: string;
}

const ReportFooter: React.FC<ReportFooterProps> = ({ customerName, generatedOn }) => {
    const updateLabel = `Atualização: ${formatManagementGeneratedOn(generatedOn)}`;

    return (
        <footer className="management-overview-footer">
            <span className="management-overview-footer__label">
                Relatório Gráfico de Gestão Mensal Indicadores de Performance | {customerName}
            </span>
            <span className="management-overview-footer__update">{updateLabel}</span>
        </footer>
    );
};

export default ReportFooter;
